import React, { ReactNode } from "react";

interface AlertProps {
  message: ReactNode;
  level: "info" | "warn" | "error" | "success";
}

const alertLevels = {
  info: "alert-info",
  warn: "alert-warn",
  error: "alert-error",
  success: "alert-success",
};

const Alert: React.FC<AlertProps> = ({ message, level }) => {
  return <div className={`alert ${alertLevels[level]}`}>{message}</div>;
};

export default Alert;
